import { CommitementDetails } from "../../../../types/Dossiers";
import CommitmentCard from "./Commitment/CommitmentCard";
import LinearProgressWithLabel from "../../../UIElements/LinearProgressWithLabel";
import { Box, Grid, Typography } from "@mui/material";
import { getColorByPercent, getLinearProgressLabelByUserRole } from "../utils";
import { useLocalStorage } from "../../../../hooks";
import { RolesEnum, Session } from "../../../../types";
import { sessionStorageKey } from "../../../../consts";
import { DossierInfosType } from "../Dossier";

type CommitementsListProps = {
    commitements: CommitementDetails[];

    dossierInfos: DossierInfosType;
    linearProgressValue: number;
};

export default function Commitements({
    commitements,
    dossierInfos,
    linearProgressValue,
}: CommitementsListProps) {
    const { storedValue: session } =
        useLocalStorage<Session>(sessionStorageKey);

    const {
        auth: { user: currentUser, currentUserRoleId: userRoleId },
    } = session;

    const commitementsSortedDescByPosition: CommitementDetails[] =
        commitements.sort((cPrev, cNext) => cPrev.position - cNext.position);

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2rem",
                alignSelf: "stretch",
            }}
        >
            {userRoleId !== RolesEnum.SYNERPA ? (
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-start",
                        gap: "1rem",
                        alignSelf: "stretch",
                    }}
                >
                    <Typography
                        sx={{
                            color: "#023",

                            fontFamily: "Roboto",
                            fontSize: "1.125rem",
                            fontStyle: "normal",
                            fontWeight: 500,
                            lineHeight: "normal",
                            alignSelf: "stretch",
                        }}
                    >
                        {getLinearProgressLabelByUserRole(userRoleId)}
                    </Typography>
                    <LinearProgressWithLabel
                        value={linearProgressValue}
                        classes={{
                            linearProgressSx: {
                                ".MuiLinearProgress-bar": {
                                    backgroundColor:
                                        getColorByPercent(linearProgressValue),
                                },
                            },
                            rootsx: {
                                "@media (max-width:1024px)": {
                                    width: "100%",
                                },
                            },
                        }}
                    />
                </Box>
            ) : null}

            <Grid container spacing={2}>
                {commitementsSortedDescByPosition.map(
                    (commitementInfos: CommitementDetails) => {
                        return (
                            <Grid item xs={12} sm={6} key={commitementInfos.id}>
                                <CommitmentCard
                                    commitmentInfos={commitementInfos}
                                    dossierInfos={dossierInfos}
                                />
                            </Grid>
                        );
                    }
                )}
            </Grid>
        </Box>
    );
}
